import React, { useEffect } from "react";
import Card from "components/card";
import { connect } from "react-redux";
import TrainingClassForm from "./TrainingClassForm";
import PopupButton from "components/button/PopupButton";
import { 
	getTrainingClassList, 
} from "../../../../redux/trainingclass/trainingClassState";
import SearchFilter from "components/search/SearchFilter";
import {  MODULE_TRAINING_CLASS } from "variables/constants";
import TrainingClassCard from "./TrainingClassCard";
import { Pagination } from "antd";
import { GraduationCap } from "lucide-react";



const TrainingClassTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters,
}) => {
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page });
	}, [doSearch, pagination.per_page ]);
	
  	return (
	    <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 dark-mode-card">
			<div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
				<div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
					<div>
						<h4 className="text-[16px] leading-none title-text">
							Training Courses
						</h4>
						<p className="text-[13px] muted-text">
							Browse all available training programs - Data synced from Client access
						</p>
					</div>
					<div className="w-[400px]">
						<SearchFilter placeholder="Search by title..." searchHandler={doSearch} filters={filters} pagination={pagination}/>
					</div>
					<PopupButton 
						id="add_trainingClass" 
						title="Add Course" 
						label="Add" 
						btnClass="btn-small" 
						action="add" 
						moduleId={MODULE_TRAINING_CLASS}
						useCustomClass={true}
					>
						<TrainingClassForm recordId="0" mode="edit" />
					</PopupButton>
				</div>
			</div>
			<div className="px-6 pb-6">
				<div className="space-y-4">
					{recordList && recordList.length > 0 ? (
					recordList.map((course) => 
						<TrainingClassCard 
							key={course.tcl_id}
							recordData={course}
						/>)
					) : (
					<div className="text-center py-12">
						<GraduationCap className="w-12 h-12 text-slate-700 mx-auto mb-4"/>
						<p className="text-slate-700">No courses found matching the filters</p>
					</div>
					)}
				</div>
				<div className="flex justify-end py-4">
					<Pagination
						current={pagination.current_page}
						pageSize={pagination.per_page}
						total={pagination.total}
						showSizeChanger={false}
						onChange={(page) =>
						doSearch({
							...filters,
							page,
							paginate: pagination.per_page,
						})
						}
					/>
				</div>
			</div>
		</Card>
  	);
};



const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassList?.items,
	pagination: state.trainingClass.trainingClassList?.pagination,
	filters: state.trainingClass.trainingClassList?.filters,
	requesting: state.trainingClass.trainingClassList?.requesting,
	error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassTable);
